import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

import { UserData } from "../types/userData";

export const fetchDetails = createAsyncThunk<UserData, string, ThunkConfig<ApiError>>(
  "user/fetchDetails",
  async (id, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<UserData>(`/api/users/${id}`);

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
